import ViewConstructor from './../components/ViewConstructor';
import { getUrlParameter } from './../../_util';

class GalleryLogin extends ViewConstructor {
  /**
    Function fired on mount.

    This adds event listeners for form submission and form mode change (create account or login)
  */
  componentDidEnter() {
    let that = this;
    let $ref = $(`#${ this.state.generatedId }`);

    $ref.find('.gallery-form-login').off().on('submit', function(e) {
      if (e) { e.preventDefault(); }

      let mode = $ref.find('.login-container').attr('data-mode');

      that.handleSignIn(mode);
    }); 

    $ref.find('.change-form-type').off().on('click', function(e) {
      if (e) { e.preventDefault(); }
      let mode = $(this).attr('data-mode');

      if (mode === 'login') {
        history.pushState(window.location.pathname, 'state', `${ that.state.baseUrl }/my-account/create`);
      } else {
        history.pushState(window.location.pathname, 'state', `${ that.state.baseUrl }/my-account/login`);
      }

      that.changeFormType(mode);
    });

    if (window.location.pathname.indexOf('create') === -1) {
      that.changeFormType('login');
    } else {
      that.changeFormType('create');
    }

    $(window).trigger('hide-create-account');

    let hasUser = this.cookie.getJSON('gallery-user');

    if (hasUser && hasUser.email) {
      $ref.find('#my-account-home').trigger('click');
    }

    var passwordWasReset = getUrlParameter('password-reset');

    if (passwordWasReset) {
      var successRef = $(`#${ this.state.generatedId } .success`);
      successRef.find('p').text('Your password was reset');
      successRef.slideDown();

      setTimeout(() => {
        successRef.slideUp();
      }, 1500);
    }
  }


  /**
    Handles sign in or create an account
  */
  handleSignIn(mode) {
    let $ref = $(`#${ this.state.generatedId }`);
    let $loginContainer = $ref.find('.login-container');
    let errRef = $ref.find('.errors');

    let email = $ref.find('input[name="gallery_email"]').val();
    let pw = $ref.find('input[name="gallery_password"]').val();

    let user = {
      email: email,
      password: pw,
    };
    
    function addLoading() {
      $loginContainer.addClass('is-loading');
    }
    function removeLoading() {
      $loginContainer.removeClass('is-loading');
    }
    function resetForm() {
      $loginContainer.find('input').val('');
    }

    if (mode === 'create') {
      let confirmPw = $ref.find('input[name="gallery_password_confirm"]').val();
      // confirm passwords match

      let checkForCookie = this.cookie.getJSON('gallery-user');

      if (checkForCookie && checkForCookie.token) {
        user.token = checkForCookie.token;
      }

      // create account
      if (confirmPw === user.password) {
        addLoading();
        this.state.api.createAccount(user, (res) => {
          removeLoading();
          if (res.success) {
            // redirect user to manage account page
            resetForm();
            $ref.find('#my-account-home').trigger('click');
          } else {
            errRef.find('p').text(res.error);
            $ref.find('.errors').slideDown();

            if (res.error === "This email address has already been registered.") {
              $ref.find('.login-container').addClass('show-forgot-login');
            }
          }
        });
      } else {
        errRef.find('p').text('Those passwords don\'t match. Please type your password correctly in both fields.');
        $ref.find('.errors').slideDown();
      }
    } else {
      
      // login to account
      addLoading();
      this.state.api.loginToAccount(user, (res) => {
        removeLoading();

        if (res.success) {
          // redirect user to manage account page
          // reset forms to default
          resetForm();
          $ref.find('#my-account-home').trigger('click');
        } else {
          // show error message
          errRef.find('p').text('The email and/or the password you entered do not match our records. Please try again or tap "I forgot my password," below.');
          $ref.find('.errors').slideDown();
        }
      });
    }
  } 



  changeFormType(mode) {
    let $ref = $(`#${ this.state.generatedId }`);
    let loginContainer = $ref.find('.login-container');
    let errRef = $ref.find('.errors');

    if (mode) {
      errRef.find('p').text('');
      $ref.find('.errors').hide();

      loginContainer.attr('data-mode', mode);
    }
  }

  render() {
    return `
      <div class="login-container" data-mode="login">
        <h2><span class="login">Sign In To</span><span class="create">Create</span> Your Account</h2>
        <div class="errors">
          <p></p>
        </div>
        <div class="success">
          <p></p>
        </div>
        <form class="gallery-form-login gallery-form">
          <label for="gallery_email">
            <span>Email:</span>
            <input type="email" name="gallery_email" required />
          </label>
          <label for="gallery_password">
            <span>Password:</span>
            <input type="password" name="gallery_password" required />
          </label>
          <label for="gallery_password_confirm">
            <span>Confirm Password:</span>
            <input type="password" name="gallery_password_confirm" />
          </label>
          <div class="login-container__button-container">
            <button type="submit" class="gallery-btn-login"><span class="login">Sign In</span><span class="create">Create Account</span></button>
          </div>
        </form>
        <div class="login-container__change-form-type">
          <a class="forgot-password" href="/gallery/my-account/forgot-password"><em class="login">I forgot my password.</em></a>
          <a class="no-account"><em class="login change-form-type" data-mode="create">I don't have an account.</em><em class="create change-form-type" data-mode="login">I have an account.</em></a>
        </div>

        <div class="hide">
          <a href="/gallery/my-account/" id="my-account-home"></a>
        </div>
      <div>
    `;
  }
}

export default GalleryLogin;


// WEBPACK FOOTER //
// ./src/scripts/site/account-views/login.js